/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentStateField } from './ConversationalAgentStateField';
import {
  ConversationalAgentStateFieldFromJSON,
  ConversationalAgentStateFieldFromJSONTyped,
  ConversationalAgentStateFieldToJSON,
} from './ConversationalAgentStateField';

/**
 * Read serializer with fully nested fields.
 * @export
 * @interface ConversationalAgentStateSchemaDetail
 */
export interface ConversationalAgentStateSchemaDetail {
  /**
   *
   * @type {number}
   * @memberof ConversationalAgentStateSchemaDetail
   */
  readonly id: number;
  /**
   *
   * @type {Array<ConversationalAgentStateField>}
   * @memberof ConversationalAgentStateSchemaDetail
   */
  readonly fields: Array<ConversationalAgentStateField>;
}

/**
 * Check if a given object implements the ConversationalAgentStateSchemaDetail interface.
 */
export function instanceOfConversationalAgentStateSchemaDetail(
  value: object,
): value is ConversationalAgentStateSchemaDetail {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('fields' in value) || value['fields'] === undefined) return false;
  return true;
}

export function ConversationalAgentStateSchemaDetailFromJSON(json: any): ConversationalAgentStateSchemaDetail {
  return ConversationalAgentStateSchemaDetailFromJSONTyped(json, false);
}

export function ConversationalAgentStateSchemaDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConversationalAgentStateSchemaDetail {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    fields: (json['fields'] as Array<any>).map(ConversationalAgentStateFieldFromJSON),
  };
}

export function ConversationalAgentStateSchemaDetailToJSON(
  value?: Omit<ConversationalAgentStateSchemaDetail, 'id' | 'fields'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {};
}
